import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './assets/css/main.css'
import './assets/css/style.css'
import App from './App.jsx'
import { ThemeProvider } from './components/theme/ThemeProvider.jsx';
import { CLIENT_ID } from './utils/constants.js'
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Provider } from 'react-redux'
import { store } from './store.js'
import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './services/queryClient';

createRoot(document.getElementById('root')).render(
  <HelmetProvider>
  <StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
      <GoogleOAuthProvider clientId={CLIENT_ID}>
        <ThemeProvider>
          <App /> 
        </ThemeProvider>
      </GoogleOAuthProvider>
      </QueryClientProvider>
    </Provider>
  </StrictMode>
  </HelmetProvider>
)